import { DrEntity } from './dr-entity';

export class PreviewField extends DrEntity {
   name: string;
   value: string;

   constructor(value?: Partial<PreviewField>) {
       super(value);
       if (value) {
           Object.assign(this, value);
       }
   }
}
